import React, { Component } from "react";
import "./special-offer.css";
import { Link } from "react-router-dom";
import { HttpService } from "../../../services/http/http-service";

//#7794 special offers commited
class SpecialOfferCatagory extends Component {
  constructor(props) {
    super(props);

    if (JSON.parse(localStorage.getItem("packageCatagories"))) {
      let localitem = JSON.parse(localStorage.getItem("packageCatagories"));
      this.state = {
        items: localitem[2],
        isLoaded: true,
      };
    } else {
      this.state = {
        items: [],
        isLoaded: false,
      };
    }
  }

  async componentDidMount() {
    if (this.props.match.params.catagory == "Holidays Type") {
      let catagory = "Holiday Type";
    } else {
      let catagory = "Special Offer";
    }

    if (JSON.parse(localStorage.getItem("packageCatagories"))) {
      ///
    } else {
      this.getPackageCatagories();
    }
  }

  getPackageCatagories() {
    let relativePath = "/MasterDatas/GetMasterDatas?SearchType=PACKAGECATEGORY";

    this.setState({ isLoading: true });
    HttpService.getServicePackage(relativePath)
      .then((response) => {
        this.setState({ isLoading: false });
        let responseData = response.data;
        if (response.status === 200) {
          localStorage.setItem(
            "packageCatagories",
            JSON.stringify(responseData.packageCatagories)
          );
          this.setState({
            items: responseData.packageCatagories[2],
          });
        } else {
          // console.log("responseData error1 ");
        }
      })
      .catch((error) => {
        // console.log("responseData error2 ");
      });
  }

  showPackageLists = (a) => {
    //  this.router.navigate(['/package-details']);
    let path = "/package-lists/" + a;
    window.location.assign(path);
  };

  render() {
    var { isLoaded, items } = this.state;
    if (!isLoaded) {
      return <div>loading Special Offer 2...{isLoaded}</div>;
    } else {
      return (
        <div className="special-offer container pt-0">
          <h1 className="text-center special-offer-head">
            {this.props.match.params.catagory}
          </h1>

          <div class="row row-cols-1 row-cols-md-2">
            {items.packageTypes.map((item) => (
              <div class="col-lg-4 col-md-6 mb-4" key={item} value={item}>
                <div class="card">
                  <div
                    className="card-img"
                    style={{ backgroundImage: "url(" + item.imagePath + ")" }}
                  ></div>
                  <div class="card-body">
                    <h5 class="card-title">{item.name}</h5>
                    <button
                      type="button"
                      className="btn et-btn"
                      onClick={() => this.showPackageLists(item.id)}
                    >
                      {" "}
                      MORE{" "}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }
  }
}

export default SpecialOfferCatagory;
